export default function () {
  this.loadPage()
}
